export default __webpack_public_path__ + "static/media/time.d6701f72.png";